import { DefaultError, useQuery } from '@tanstack/react-query';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IMusicProductDigitalLight } from './types/query';

export const useGetMusicProductDigitalLightList = () => {
  const { responseHandler } = useResponseHandler();
  return useQuery<IMusicProductDigitalLight[], DefaultError>({
    queryKey: ['mpd-light-list'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `MusicProductDigital/LightList`,
      });

      return responseHandler(response, {
        groupName: `useGetMusicProductDigitalLightList`,
      });
    },
  });
};
